import { render } from "./OperatorsPage.vue?vue&type=template&id=f44f3640&scoped=true"
import script from "./OperatorsPage.vue?vue&type=script&lang=js"
export * from "./OperatorsPage.vue?vue&type=script&lang=js"

import "./OperatorsPage.vue?vue&type=style&index=0&id=f44f3640&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f44f3640"]])

export default __exports__